import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Col, Row } from 'reactstrap';
import FormInputSimples from '../../../comum/components/FormInputSimples';
import Card from '../../../comum/components/Card';
import FormOnlyPositiveNumberSimples from '../../../comum/components/FormNumberSimples';
import { IconeCarregar } from './../../../comum/components/Icones';

@observer
export class FiltroRelAnalitico extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        return(
            <div className="filtros filtro-analise-critica">
                <Card className="area-form pb-0">
                    <Row>
                        <FormOnlyPositiveNumberSimples
                            titulo="CE" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setCe(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="BL" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setBl(event.target.value) }
                        />
                        <FormInputSimples
                            titulo="DA" xs={12} sm={12} md={4} lg={4} xl={2}
                            onEnter={this.controller.baixar}
                            onChange={(event) => this.controller.setDa(event.target.value) }
                        />
                        <Col className="col-botoes align-items-end mb-4" xl={3} lg={4} md={6} sm={12} xs={12}>
                            <Button
                                onClick={this.controller.baixar}
                                className="btn-com-bordas-primary btn-baixar"
                                disabled={this.controller.loading}
                            >
                                {
                                    this.controller.loading
                                    ? <IconeCarregar cor="#fff" tamanho="lg" />
                                    : "Baixar"
                                }
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatorioanalitico/components/FiltroRelAnalitico.js